// ** IMPORTANT **: Keep in sync with functions/src/index.ts BOOK_INVITE_CLAIM_CALLABLE_ERROR_REASON
export enum BOOK_INVITE_CLAIM_CALLABLE_ERROR_REASON {
    revoked = 'revoked',
    expired = 'expired',
    notClaimable = 'not-claimable',
    ownerAlreadyHasBookAccess = 'owner-already-has-book-access',
}
